import { Outlet } from 'react-router-dom';
import CelebrationNavHeader from '@/components/guest/CelebrationNavHeader';
import CelebrationFooter from '@/components/guest/CelebrationFooter';
import CookieBanner from '@/components/guest/CookieBanner';
import '../../styles/doughnut-shop.css';

const GuestLayout = () => {
  return (
    <div className="min-h-screen">
      <CelebrationNavHeader />
      <main>
        <Outlet />
      </main>
      <CelebrationFooter />
      <CookieBanner />
    </div>
  );
};

export default GuestLayout;
